import { render, staticRenderFns } from "./ContextualDialogBulk.vue?vue&type=template&id=1dd56ff2&scoped=true&"
import script from "./ContextualDialogBulk.vue?vue&type=script&lang=js&"
export * from "./ContextualDialogBulk.vue?vue&type=script&lang=js&"
import style0 from "./ContextualDialogBulk.vue?vue&type=style&index=0&id=1dd56ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd56ff2",
  null
  
)

export default component.exports